import { Feedback, FeedbackContentType } from 'v2/core/entities/feedback';

export const isFeedbackSummaryPresent = (feedback: Feedback) => {
  if (feedback.content.type === FeedbackContentType.Audio) {
    return false;
  }

  return Boolean(feedback.content.summary?.units?.length);
};
